<template>
  <div class="payout">
    <table-payout></table-payout>
  </div>
</template>
<script>
import tablePayout from "@/components/finance/table-payout.vue";
export default {
  components: { tablePayout }
};
</script>
